// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"286a3813","842":"4ad1b845","913":"8f85880e","998":"a6c9c64e"}[chunkId] + ".chunk.js";
};